import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NotificationEntry } from '@freelancer/datastore/collections';
import { Assets } from '@freelancer/ui/assets';

@Component({
  selector: 'app-notification-item',
  template: `
    <app-feed-item
      class="NotificationItem"
      [link]="event.data.linkUrl"
      [users]="[{ avatar: defaultThumbnailUrl }]"
      flTrackingLabel="NotificationFeedItem"
      thumbnail="image"
      thumbnailAlt="Relevant notification image thumbnail"
      [size]="size"
    >
      <ng-container [ngSwitch]="event.type">
        <app-notification-template-article-comment
          [event]="event"
          *ngSwitchCase="'articleCommentReceived'"
        >
        </app-notification-template-article-comment>
        <app-notification-template-award-milestone-reminder
          [event]="event"
          *ngSwitchCase="'awardMilestoneReminder'"
        >
        </app-notification-template-award-milestone-reminder>
        <app-notification-template-award-reminder
          [event]="event"
          *ngSwitchCase="'awardReminder'"
        >
        </app-notification-template-award-reminder>
        <app-notification-template-award
          [event]="event"
          *ngSwitchCase="'award'"
        >
        </app-notification-template-award>
        <app-notification-template-award-badge
          [event]="event"
          *ngSwitchCase="'awardBadge'"
        >
        </app-notification-template-award-badge>
        <app-notification-template-award-credit
          [event]="event"
          *ngSwitchCase="'awardCredit'"
        >
        </app-notification-template-award-credit>
        <app-notification-template-award-xp
          [event]="event"
          *ngSwitchCase="'awardXp'"
        >
        </app-notification-template-award-xp>
        <app-notification-template-bid [event]="event" *ngSwitchCase="'bid'">
        </app-notification-template-bid>
        <app-notification-template-contest-entry-awarded-employer
          [event]="event"
          *ngSwitchCase="'contestAwardedToEmployer'"
        >
        </app-notification-template-contest-entry-awarded-employer>
        <app-notification-template-contest-entry-awarded-freelancer
          [event]="event"
          *ngSwitchCase="'contestAwardedToFreelancer'"
        >
        </app-notification-template-contest-entry-awarded-freelancer>
        <app-notification-template-contest-entry-bought-employer
          [event]="event"
          *ngSwitchCase="'contestEntryBoughtToEmployer'"
        >
        </app-notification-template-contest-entry-bought-employer>
        <app-notification-template-contest-entry-bought-freelancer
          [event]="event"
          *ngSwitchCase="'contestEntryBoughtToFreelancer'"
        >
        </app-notification-template-contest-entry-bought-freelancer>
        <app-notification-template-contest-entry-commented-to-freelancer
          [event]="event"
          *ngSwitchCase="'contestEntryCommentedToFreelancer'"
        ></app-notification-template-contest-entry-commented-to-freelancer>
        <app-notification-template-contest-entry-rated-to-freelancer
          [event]="event"
          *ngSwitchCase="'contestEntryRatedToFreelancer'"
        ></app-notification-template-contest-entry-rated-to-freelancer>
        <app-notification-template-contest-entry-rejected-to-freelancer
          [event]="event"
          *ngSwitchCase="'contestEntryRejectedToFreelancer'"
        ></app-notification-template-contest-entry-rejected-to-freelancer>
        <app-notification-template-contest-entry-reconsidered-to-freelancer
          [event]="event"
          *ngSwitchCase="'contestEntryReconsideredToFreelancer'"
        ></app-notification-template-contest-entry-reconsidered-to-freelancer>
        <app-notification-template-contest-entry
          [event]="event"
          *ngSwitchCase="'contestEntry'"
        >
        </app-notification-template-contest-entry>
        <app-notification-template-contest-pcb-notification
          [event]="event"
          *ngSwitchCase="'contestPCBNotification'"
        >
        </app-notification-template-contest-pcb-notification>
        <app-notification-template-contest-pcb-notification-full-view
          [event]="event"
          *ngSwitchCase="'contestPCBNotificationFullView'"
        >
        </app-notification-template-contest-pcb-notification-full-view>
        <app-notification-template-create-milestone
          [event]="event"
          *ngSwitchCase="'createMilestone'"
        >
        </app-notification-template-create-milestone>
        <app-notification-template-draft-contest
          [event]="event"
          *ngSwitchCase="'draftContest'"
        >
        </app-notification-template-draft-contest>
        <app-notification-template-deny
          [event]="event"
          *ngSwitchCase="'denyed'"
        >
        </app-notification-template-deny>
        <app-notification-template-failing-project
          [event]="event"
          *ngSwitchCase="'failingProject'"
        >
        </app-notification-template-failing-project>
        <app-notification-template-giveget-child-received-signup-bonus
          [event]="event"
          *ngSwitchCase="'giveGetChildReceivedSignupBonus'"
        >
        </app-notification-template-giveget-child-received-signup-bonus>
        <app-notification-template-task-create
          [event]="event"
          *ngSwitchCase="'tasklistCreateV1'"
        >
        </app-notification-template-task-create>
        <app-notification-template-giveget-child-signup
          [event]="event"
          *ngSwitchCase="'giveGetChildSignUp'"
        >
        </app-notification-template-giveget-child-signup>
        <app-notification-template-giveget-child-partial-milestone-release
          [event]="event"
          *ngSwitchCase="'giveGetChildPartialMilestoneRelease'"
        >
        </app-notification-template-giveget-child-partial-milestone-release>
        <app-notification-template-giveget-parent-bonus
          [event]="event"
          *ngSwitchCase="'giveGetParentBonus'"
        >
        </app-notification-template-giveget-parent-bonus>
        <app-notification-template-follower
          [event]="event"
          *ngSwitchCase="'notifyfollower'"
        >
        </app-notification-template-follower>
        <app-notification-template-invite-to-contest
          [event]="event"
          *ngSwitchCase="'inviteToContest'"
        >
        </app-notification-template-invite-to-contest>
        <app-notification-template-invite-user-bid
          [event]="event"
          *ngSwitchCase="'inviteUserBid'"
        >
        </app-notification-template-invite-user-bid>
        <app-notification-template-invoice-requested
          [event]="event"
          *ngSwitchCase="'invoiceRequested'"
        >
        </app-notification-template-invoice-requested>
        <app-notification-template-level-up
          [event]="event"
          *ngSwitchCase="'levelUp'"
        >
        </app-notification-template-level-up>
        <app-notification-template-project-completed
          [event]="event"
          *ngSwitchCase="'completed'"
        >
        </app-notification-template-project-completed>
        <app-notification-template-quick-hire-project
          [event]="event"
          *ngSwitchCase="'quickHireProject'"
        >
        </app-notification-template-quick-hire-project>
        <app-notification-template-quick-hire-project
          [event]="event"
          *ngSwitchCase="'hireMe'"
        >
        </app-notification-template-quick-hire-project>
        <app-notification-template-release-milestone
          [event]="event"
          *ngSwitchCase="'releaseMilestone'"
        >
        </app-notification-template-release-milestone>
        <app-notification-template-request-end-project
          [event]="event"
          *ngSwitchCase="'requestEndProject'"
        >
        </app-notification-template-request-end-project>
        <app-notification-template-request-milestone
          [event]="event"
          *ngSwitchCase="'requestMilestone'"
        >
        </app-notification-template-request-milestone>
        <app-notification-template-request-to-release
          [event]="event"
          *ngSwitchCase="'requestToRelease'"
        >
        </app-notification-template-request-to-release>
        <app-notification-template-service-approved
          [event]="event"
          *ngSwitchCase="'serviceApproved'"
        >
        </app-notification-template-service-approved>
        <app-notification-template-service-project-ending
          [event]="event"
          *ngSwitchCase="'serviceProjectEndingSeller'"
        >
        </app-notification-template-service-project-ending>
        <app-notification-template-service-project-posted
          [event]="event"
          *ngSwitchCase="'serviceProjectPostedSeller'"
        >
        </app-notification-template-service-project-posted>
        <app-notification-template-service-rejected
          [event]="event"
          *ngSwitchCase="'serviceRejected'"
        >
        </app-notification-template-service-rejected>
        <app-notification-template-showcase-source-approval
          [event]="event"
          *ngSwitchCase="'showcaseSourceApproval'"
        >
        </app-notification-template-showcase-source-approval>
        <app-notification-template-sign-up-free-trial-upsell
          [event]="event"
          *ngSwitchCase="'signUpFreeTrialUpsell'"
        >
        </app-notification-template-sign-up-free-trial-upsell>
        <div *ngSwitchDefault>
          <app-notification-template-default
            [error]="
              'Missing notification template component for: ' + event.type
            "
          ></app-notification-template-default>
        </div>
      </ng-container>
      <ng-content></ng-content>
      <div>
        <fl-relative-time
          [date]="event.time"
          [suffix]="true"
        ></fl-relative-time>
      </div>
    </app-feed-item>
  `,
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent implements OnInit {
  @Input() event: NotificationEntry;
  @Input() size: 'small' | 'mid';
  defaultThumbnailUrl: string;

  constructor(private assets: Assets) {}

  ngOnInit() {
    this.defaultThumbnailUrl =
      this.event.data.imgUrl ||
      this.assets.getUrl('default-notification-image.svg');
  }
}
